(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-size-guide-modal';
  var TABS_SELECTOR = '.oddit-section-size-guide-modal__tabs';
  var TAB_SELECTOR = '.oddit-section-size-guide-modal__tab';
  var PANEL_SELECTOR = '[data-tab-panel]';
  var ACTIVE_CLASS = 'oddit-section-size-guide-modal__tab--active';
  var OPEN_SELECTOR = '[data-size-guide-open]';
  var BODY_OPEN_CLASS = 'oddit-size-guide-open';
  var UNIT_ACTIVE_CLASS = 'oddit-section-size-guide-modal__unit--active';

  // Element that opened the modal, so focus can be restored on close.
  var lastTrigger = null;

  // Post the fit-finder form in place. A native submit reloads the product page
  // with the modal closed (and drops any `view=` param), so the shopper never
  // sees that it worked. Falls through to the native submit if fetch is absent.
  function initFormSubmit(section) {
    var form = section.querySelector('.oddit-section-size-guide-modal__form');
    if (!form || typeof window.fetch !== 'function') return;

    form.addEventListener('submit', function (e) {
      if (!form.checkValidity()) return;
      e.preventDefault();

      var button = form.querySelector('.oddit-section-size-guide-modal__form-button');
      if (button) button.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      })
        .then(function (res) {
          showFormMessage(section, form, res.ok);
          if (res.ok) form.reset();
        })
        .catch(function () {
          showFormMessage(section, form, false);
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    });
  }

  // Replace any previous banner with the outcome of the latest submit.
  function showFormMessage(section, form, ok) {
    var existing = form.querySelector('[data-size-guide-posted]');
    if (existing) existing.remove();

    var el = document.createElement('p');
    el.className = ok
      ? 'oddit-section-size-guide-modal__form-success'
      : 'oddit-section-size-guide-modal__form-error';
    el.setAttribute('data-size-guide-posted', '');
    el.setAttribute('role', ok ? 'status' : 'alert');
    var card = form.closest('.oddit-section-size-guide-modal__form-card');
    el.textContent = ok
      ? (card && card.getAttribute('data-success-text')) || 'Thanks! We will email you a size recommendation shortly.'
      : 'Something went wrong. Please try again.';

    form.insertBefore(el, form.firstChild);
    el.scrollIntoView({ block: 'nearest' });
  }

  // Scroll a tab to the horizontal center of its slider without affecting
  // page scroll (so partially-hidden tabs center themselves on click).
  function centerTab(tab) {
    var tabs = tab.closest(TABS_SELECTOR);
    if (!tabs) return;
    var target = tab.offsetLeft - (tabs.clientWidth - tab.offsetWidth) / 2;
    tabs.scrollTo({ left: target, behavior: 'smooth' });
  }

  // Show the tab panel whose data-tab-panel matches tabName; hide the rest.
  function switchPanel(section, tabName) {
    if (!tabName) return;
    var panels = section.querySelectorAll(PANEL_SELECTOR);
    panels.forEach(function (panel) {
      if (panel.getAttribute('data-tab-panel') === tabName) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  // Mark tabName's tab active, deactivate the rest, and reveal its panel.
  function activateTab(section, tabName) {
    var tabs = section.querySelectorAll(TAB_SELECTOR);
    tabs.forEach(function (t) {
      var isTarget = t.getAttribute('data-tab') === tabName;
      t.classList.toggle(ACTIVE_CLASS, isTarget);
      t.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      if (isTarget) centerTab(t);
    });
    switchPanel(section, tabName);
  }

  // Unit pickers (CM/IN, LBS/KG): highlight the chosen unit and mirror it
  // into the hidden input so it submits with the contact form.
  function initUnitGroups(section) {
    section.querySelectorAll('[data-size-guide-units]').forEach(function (group) {
      var buttons = group.querySelectorAll('[data-unit]');
      var valueInput = group.querySelector('[data-size-guide-unit-value]');

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          buttons.forEach(function (b) {
            var isTarget = b === button;
            b.classList.toggle(UNIT_ACTIVE_CLASS, isTarget);
            b.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
          });
          if (valueInput) valueInput.value = button.getAttribute('data-unit');
        });
      });
    });
  }

  function initSection(section) {
    if (!section || section.dataset.odditInit === 'true') return;
    section.dataset.odditInit = 'true';

    var tabs = section.querySelectorAll(TAB_SELECTOR);
    if (tabs.length) {
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(section, tab.getAttribute('data-tab'));
        });
      });
    }

    initUnitGroups(section);
    initFormSubmit(section);

    // Submitting the contact form reloads the page with the modal closed.
    // If this render came back from a submit, reopen on the Help tab so the
    // success or error message is actually seen.
    if (section.querySelector('[data-size-guide-posted]')) {
      openModal(section, null);
      activateTab(section, 'help');
    }

    var closeBtn = section.querySelector('.oddit-section-size-guide-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(section);
      });
    }

    // Clicking the backdrop (but not the popup itself) dismisses the modal.
    section.addEventListener('click', function (e) {
      if (e.target === section) closeModal(section);
    });
  }

  function openModal(section, trigger) {
    if (!section) return;
    lastTrigger = trigger || null;

    // Both of these must land while the modal is still display:none, so the
    // opacity transitions never run and it appears fully opaque immediately.

    // oddit-interactions.css holds every .shopify-section at opacity 0 until
    // its scroll observer adds oddit-section-active. This modal is fixed and
    // display:none until opened, so that observer never fires for it.
    var shell = section.closest('.shopify-section');
    if (shell) shell.classList.add('oddit-section-active');

    // Same problem one level down: the reveal observer never saw this subtree
    // while it was hidden, which would leave its contents stuck at opacity 0.
    section.querySelectorAll('.oddit-reveal:not(.is-visible)').forEach(function (el) {
      el.classList.add('is-visible');
    });

    section.removeAttribute('hidden');
    document.body.classList.add(BODY_OPEN_CLASS);

    var closeBtn = section.querySelector('.oddit-section-size-guide-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(section) {
    if (!section || section.hasAttribute('hidden')) return;
    section.setAttribute('hidden', '');
    document.body.classList.remove(BODY_OPEN_CLASS);
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function unloadSection(section) {
    if (!section) return;
    delete section.dataset.odditInit;
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  // Delegated so triggers rendered by other sections (the Size Guide link in
  // the main product section) work without those sections knowing about us.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest(OPEN_SELECTOR);
    if (!trigger) return;

    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return; // No modal on the page: let the link navigate.

    e.preventDefault();
    openModal(section, trigger);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      closeModal(section);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) unloadSection(section);
  });
})();
